(() => {
  if (window.__MF_TASSEN_HENKELRAND_MODE__) return;
  window.__MF_TASSEN_HENKELRAND_MODE__ = true;

  const COLORS = [
    { id:'schwarz', name:'Schwarz', hex:'#171819', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-schwarz.png?v=1787768181' },
    { id:'gelb', name:'Gelb', hex:'#f3de28', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-gelb.png?v=1787768187' },
    { id:'orange', name:'Orange', hex:'#f47a22', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-orange.png?v=1787768193' },
    { id:'rot', name:'Rot', hex:'#dd3a2e', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-rot.png?v=1787768201' },
    { id:'pink', name:'Pink', hex:'#d5a0aa', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-pink.png?v=1787768208' },
    { id:'bordeaux', name:'Bordeaux', hex:'#77313f', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-bordeaux.png?v=1787768214' },
    { id:'blau', name:'Blau', hex:'#438ec2', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-blau.png?v=1787768220' },
    { id:'weiss', name:'Weiß', hex:'#f1f1ef', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-weiss.png?v=1787768226' },
    { id:'hellgruen', name:'Hellgrün', hex:'#a5bf73', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-hellgruen.png?v=1787768232' },
    { id:'gruen', name:'Grün', hex:'#2d5b32', image:'https://cdn.shopify.com/s/files/1/0973/4835/4395/files/mf-henkelrand-gruen.png?v=1787768239' }
  ];

  const selectedById = id => COLORS.find(c => c.id === id) || COLORS[0];
  const activeHost = () => document.querySelector('.mf-designer-dialog[open] [data-mf-tassen-designer-host][data-mf-mug-mode="henkelrand"]') || document.querySelector('[data-mf-tassen-designer-host][data-mf-mug-mode="henkelrand"]');

  function patchCopy(host) {
    const root = host?.shadowRoot;
    if (!root) return;
    const intro = root.querySelector('.intro h1');
    if (intro && /weiße tasse/i.test(intro.textContent || '')) intro.innerHTML = 'Deine Fototasse.<br><em>Rundum gestaltet.</em>';
    const tip = root.querySelector('.tip-box');
    if (tip) {
      const spans = tip.querySelectorAll('span');
      if (spans[0] && spans[0].textContent !== '1. Henkel- & Randfarbe auswählen') spans[0].textContent = '1. Henkel- & Randfarbe auswählen';
      if (spans[1] && spans[1].textContent !== '2. Foto und Text einfügen & ausrichten') spans[1].textContent = '2. Foto und Text einfügen & ausrichten';
      if (spans[2] && spans[2].textContent !== '3. Tasse drehen & Vorschau prüfen') spans[2].textContent = '3. Tasse drehen & Vorschau prüfen';
    }
  }

  function applyColor(host, id, notify = true) {
    if (!host) return;
    const selected = selectedById(id);
    host.dataset.mfMugMode = 'henkelrand';
    host.dataset.mfHenkelrandColorId = selected.id;
    host.dataset.mfHenkelrandColor = selected.name;
    host.dataset.mfHenkelrandColorHex = selected.hex;
    host.dataset.mfHenkelrandImage = selected.image;
    try { localStorage.setItem('mf-henkelrandfarbe-330ml', selected.id); } catch (_) {}

    const root = host.shadowRoot;
    root?.querySelectorAll('[data-mf-henkelrand-color]').forEach(button => {
      const on = button.dataset.mfHenkelrandColor === selected.id;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const label = root?.querySelector('[data-mf-henkelrand-color-label]');
    if (label && label.textContent !== selected.name) label.textContent = selected.name;
    const summary = root?.querySelector('.summary-box strong');
    if (summary && summary.textContent !== `Fototasse · ${selected.name}`) summary.textContent = `Fototasse · ${selected.name}`;
    root?.querySelectorAll('.cart-line strong').forEach(el => {
      const value = `Fototasse · ${selected.name}`;
      if (el.textContent !== value) el.textContent = value;
    });

    if (notify) {
      document.dispatchEvent(new CustomEvent('mf:henkelrand-selected', { detail:selected }));
      host.dispatchEvent(new CustomEvent('mf:henkelrand-color-change', { detail:selected }));
    }
  }

  function ensureUI(host) {
    const root = host?.shadowRoot;
    if (!root) return false;
    const controls = root.querySelector('.controls-card');
    if (!controls) return false;
    patchCopy(host);

    if (!root.querySelector('[data-mf-henkelrand-section]')) {
      const section = document.createElement('div');
      section.className = 'control-section mf-henkelrand-section';
      section.dataset.mfHenkelrandSection = '1';
      section.innerHTML = `<div class="control-label"><span>1</span><strong>Henkel- &amp; Randfarbe</strong></div><div class="mf-henkelrand-head"><small>10 Farben zur Auswahl</small><b data-mf-henkelrand-color-label></b></div><div class="mf-henkelrand-grid" role="group" aria-label="Henkel- und Randfarbe wählen">${COLORS.map(c => `<button type="button" data-mf-henkelrand-color="${c.id}" aria-pressed="false" title="${c.name}"><span class="mf-henkelrand-photo"><img src="${c.image}" alt="Tasse ${c.name}" loading="lazy"></span><span>${c.name}</span></button>`).join('')}</div>`;
      const first = controls.querySelector('.control-section');
      if (first) controls.insertBefore(section, first); else controls.appendChild(section);
      section.querySelectorAll('[data-mf-henkelrand-color]').forEach(button => button.addEventListener('click', () => applyColor(host, button.dataset.mfHenkelrandColor)));
      const sections = [...controls.querySelectorAll('.control-section')].filter(el => !el.matches('[data-mf-henkelrand-section]'));
      sections.forEach((el, index) => {
        const number = el.querySelector('.control-label > span');
        if (number && index < 2) number.textContent = String(index + 2);
      });
    }

    if (!root.querySelector('#mf-henkelrand-style')) {
      const style = document.createElement('style');
      style.id = 'mf-henkelrand-style';
      style.textContent = `.mf-henkelrand-section{border-top:0!important;padding-top:0!important}.mf-henkelrand-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:-2px 0 10px;color:#aaa}.mf-henkelrand-head small{font-size:11px}.mf-henkelrand-head b{color:#f58220;font-size:12px}.mf-henkelrand-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:7px}.mf-henkelrand-grid button{min-width:0;display:grid;grid-template-columns:62px minmax(0,1fr);align-items:center;gap:7px;padding:5px;border:1px solid rgba(255,255,255,.16);border-radius:8px;background:#232426;color:#eee;cursor:pointer}.mf-henkelrand-grid button:hover{border-color:rgba(245,130,32,.65)}.mf-henkelrand-grid button.is-active{border-color:#f58220;box-shadow:0 0 0 1px #f58220;background:rgba(245,130,32,.10)}.mf-henkelrand-photo{display:flex;width:62px;height:48px;align-items:center;justify-content:center;border-radius:6px;overflow:hidden;background:#151618;box-shadow:inset 0 0 0 1px rgba(255,255,255,.08)}.mf-henkelrand-photo img{display:block;width:90%;height:90%;object-fit:contain}.mf-henkelrand-grid button>span:last-child{min-width:0;font-size:9px;font-weight:800;line-height:1.15;text-align:left;white-space:normal}@media(max-width:520px){.mf-henkelrand-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:6px}.mf-henkelrand-grid button{grid-template-columns:48px minmax(0,1fr);padding:4px}.mf-henkelrand-photo{width:48px;height:40px}.mf-henkelrand-grid button>span:last-child{font-size:8px}}`;
      root.appendChild(style);
    }

    let selectedId = host.dataset.mfHenkelrandColorId || '';
    if (!selectedId) { try { selectedId = localStorage.getItem('mf-henkelrandfarbe-330ml') || ''; } catch (_) {} }
    applyColor(host, selectedId || 'schwarz', false);
    return true;
  }

  function watchHost(host) {
    if (!host || host.dataset.mfHenkelrandWatch === '1') return;
    host.dataset.mfMugMode = 'henkelrand';
    host.dataset.mfHenkelrandWatch = '1';
    let tries = 0;
    const tick = () => {
      tries += 1;
      const ready = ensureUI(host);
      if (ready && host.shadowRoot && !host.__mfHenkelrandShadowObserver) {
        const observer = new MutationObserver(() => ensureUI(host));
        observer.observe(host.shadowRoot, { childList:true, subtree:true });
        host.__mfHenkelrandShadowObserver = observer;
      }
      if (!ready && tries < 100) setTimeout(tick, 100);
    };
    tick();
  }

  const boot = () => document.querySelectorAll('[data-mf-tassen-designer-host][data-mf-mug-mode="henkelrand"]').forEach(watchHost);
  window.__MF_TASSEN_HENKELRAND_BOOT__ = boot;

  document.addEventListener('mf:henkelrand-select', event => {
    const host = activeHost() || document.querySelector('[data-mf-tassen-designer-host][data-mf-mug-mode="henkelrand"]');
    if (!host) return;
    applyColor(host, event.detail?.id || 'schwarz', false);
    ensureUI(host);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true }); else boot();

  if (!window.__MF_HENKELRAND_FETCH_PATCH__) {
    window.__MF_HENKELRAND_FETCH_PATCH__ = true;
    const previousFetch = window.fetch.bind(window);
    window.fetch = async function mfHenkelrandFetch(input, init = {}) {
      try {
        const url = typeof input === 'string' ? input : String(input?.url || '');
        const method = String(init?.method || 'GET').toUpperCase();
        const body = init?.body;
        if (method === 'POST' && /\/cart\/add\.js(?:\?|$)/.test(url) && body instanceof FormData) {
          const host = activeHost();
          if (host?.dataset?.mfMugMode === 'henkelrand') {
            const selected = selectedById(host.dataset.mfHenkelrandColorId || 'schwarz');
            if (!body.has('properties[Henkel- & Randfarbe]')) body.append('properties[Henkel- & Randfarbe]', selected.name);
            if (!body.has('properties[_MF Henkelrandfarbe-ID]')) body.append('properties[_MF Henkelrandfarbe-ID]', selected.id);
          }
        }
      } catch (error) { console.warn('[MF Henkelrand]', error); }
      return previousFetch(input, init);
    };
  }
})();